// ============================================================
//  src/pages/bots/tabs/AutomationsTab.js
//  Wrapper that handles nested routing for the Automations
//  feature inside BotDetailPage.
// ============================================================
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AutomationsListPage from '../automations/AutomationsListPage';
import FlowBuilderPage     from '../automations/FlowBuilderPage';

export default function AutomationsTab({ bId }) {
  return (
    <Routes>
      <Route index     element={<AutomationsListPage bId={bId} />} />
      <Route path=":aId" element={<FlowBuilderPage />} />
      <Route path="*"  element={<Navigate to="" replace />} />
    </Routes>
  );
}
